import React, { Component } from 'react'
import { CardDeck, Row, Col, Container, Card, Button, Modal } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.css';
import '../css/UpdateUserProfile.css';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Select from "react-select";
import axiosConfig from '../config/axiosConfig'
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { Toast } from 'primereact/toast';

import '../css/AdvanceDeleteButtonTable.css'
import FeatherIcon from 'feather-icons-react'

const customStyles = {
    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? "black" : "black",
        backgroundColor: state.isSelected ? "#7367f0" : "white",
    }),
    control: (provided) => ({
        ...provided,
        borderRadius: "20px",
        borderColor: "#7367f0",
    }),
};
const firstDate = new Date();
const currentDate = new Date();
class EditManualTransaction extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            Value: 0.0,
            UserID: 0,
            Price: 0.0,
            // FromDate: new Date(firstDate.getFullYear(), firstDate.getMonth(), 1).toISOString().slice(0,16),
            FromDate: new Date(currentDate.getFullYear(), currentDate.getMonth(), 2).toISOString().slice(0,16), //new Date(date.getFullYear(), date.getMonth(), 1);
            ToDate: new Date().toISOString().slice(0,16),
           // ToDate: new Date().toISOString().substring(0, 10),
            //FromDate: '',
            Product: '',
            //ToDate: '',
            Pan: '',
            createdDate: '',
            logdatetime: '',
            SelectedType: '',


            openModel: false,
            IsAmountSelected: false,

            TransactionDetaildata: [],
            PANs: [],
            Type: [
                { 'label': 'Quantity' },
                { 'label': 'Amount' },
            ],
            TransactionDetailcolumns: [
                { "HeaderText": "ID", "MappingColomn": "manualTranId" },
                { "HeaderText": "Amount", "MappingColomn": "amount" },
                { "HeaderText": "Quantity", "MappingColomn": "quantity" },
                { "HeaderText": "Outlet", "MappingColomn": "outlet" },
                { "HeaderText": "Product", "MappingColomn": "product" },
                { "HeaderText": "Date", "MappingColomn": "logDateTime" },
                { "HeaderText": "Prices", "MappingColomn": "price" },
                // { "HeaderText": "TranDetailId", "MappingColomn": "tranDetailId" }

            ],
            globalSearchBox: '',
            datakeyName: 'Hello',
            PageSize: 10,
            Object: [],
            UserBranchID: localStorage.getItem("selectedBranch")
        }


        //this.onPANChange = this.onPANChange.bind(this);
        this.changeHandler = this.changeHandler.bind(this);

        this.showModel = this.showModel.bind(this)
        this.EditedCallback = this.EditedCallback.bind(this)
        // this.DeletedCallback = this.DeletedCallback.bind(this)
        this.closeModel = this.closeModel.bind(this)

        this.onChange = this.onChange.bind(this)
        this.TransactionSaved = this.TransactionSaved.bind(this)
        this.BindManualTransactionDetailGrid = this.BindManualTransactionDetailGrid.bind(this);
        this.actionEditTemplate = this.actionEditTemplate.bind(this);
        this.actionDeleteTemplate = this.actionDeleteTemplate.bind(this);
        this.confirmDeleteProduct = this.confirmDeleteProduct.bind(this);
        this.confirmEditedProduct = this.confirmEditedProduct.bind(this);

    }

    componentWillMount() {

    }
    componentDidMount() {
        const data = {
            UserBranchID: this.props.data.selectedBranchId,
        };

        console.log('FromDate: ' + this.state.FromDate);
    }

    BindManualTransactionDetailGrid(e) {
        axiosConfig.post("Portal/GetManualTransactionDetails",
            {
                FromDate: this.state.FromDate,
                ToDate: this.state.ToDate,
                UserBranchID: this.props.data.selectedBranchId,
            }
        )
            .then(res => {
                this.setState({
                    TransactionDetaildata: res.data.trandetails,
                    UserBranchID: this.state.UserBranchID
                })

            })
            .catch(error => {
                Swal.fire({
                    title: error.response.data.errorMessage,
                    text: 'Some Error !',
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            })

    }

    EditedCallback = (ChildData) => {
        console.log(this.state.UserID);
        this.showModel();
    }

    showModel = (e) => {
        this.setState({ openModel: true });
    }

    closeModel(e) {
        this.setState({ openModel: false });
    }


    changeHandler(p) {
        var newState = {};
        newState[p.target.name] = p.target.value;
        this.setState(newState);
    }


    TransactionSaved = (e) => {
        axiosConfig.post("Portal/EditManualTransaction",
            {
                TransDetailId: this.state.UserID,
                Value: this.state.Value,
                IsAmount: this.state.IsAmountSelected,
                Product: this.state.Product,
                Price: this.state.Price,
                UserBranchID: this.state.UserBranchID
            }

        )
            .then(Response => {
                this.setState({ openModel: false });
                Swal.fire({
                    icon: 'success',
                    title: Response.data.status.description,
                })

            })
            .catch(error => {
                this.setState({ openModel: false });
                Swal.fire({
                    title: error.res.data.errorMessage,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            })

    }


    onChange(selectedOption) {

        console.log('selectedOption: ', selectedOption);

        if (selectedOption.label == 'Quantity') {
            this.setState({
                SelectedType: 'Quantity',
                IsAmountSelected: false,
            });
        }
        else if (selectedOption.label == 'Amount') {

            this.setState({
                SelectedType: 'Amount',
                IsAmountSelected: true,
            });
        }

    }

    actionEditTemplate(rowData) {

        return (
            <React.Fragment>
                <a onClick={() => this.confirmEditedProduct(rowData)}>
                    <FeatherIcon icon="plus-square" size="20" />
                </a>
            </React.Fragment>
        );
    }

    actionDeleteTemplate(rowData) {

        return (
            <React.Fragment>
                <a onClick={() => this.confirmDeleteProduct(rowData)}>
                    <FeatherIcon icon="trash-2" size="20" />
                </a>
            </React.Fragment>
        );
    }

    async confirmDeleteProduct(row) {
        console.log("Deleted Object");
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to undo this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it'
        }).then((result) => {
            if (result.isConfirmed) {
                this.setState({ Object: row });
                axiosConfig.post("Portal/DeleteManualTransaction",
                    {
                        ManualTranId: row.manualTranId,
                        UserBranchID: this.state.UserBranchID
                    }

                )
                    .then(Response => {
                        this.setState({ openModel: false });
                        Swal.fire({
                            icon: 'success',
                            title: Response.data.status.description,
                        })
                         this.BindManualTransactionDetailGrid()

                    })
                    .catch(error => {
                        this.setState({ openModel: false });
                        Swal.fire({
                            title: error.response.data.errorMessage,
                            icon: 'error',
                            confirmButtonText: 'Okay'
                        })
                    })
            }
        })
    }

    async confirmEditedProduct(Row) {

        await this.setState({ Object: Row });
        this.showModel();
        this.setState({
            UserID: Row.tranDetailId,
            Product: Row.product,
            Price: Row.price

        });
    }

    render() {

        return (
            <>
                <Row className="p-3">
                    <Card className="p-3" style={{ width: "100%" }}>
                        <Card.Title>
                            <div className="pull-left">
                                View/Edit Manual Transaction
                                <br></br>
                            </div>
                        </Card.Title>

                        <Card.Body>
                            <Row className="justify-content-center align-items-center">
                                <div className="col-md-3 col-12">
                                    <label className="font-weight-bold text-right">From Dates</label>
                                </div>
                                <div className="col-md-4 col-12">
                                    <div className="form-label-group">
                                        <input type="datetime-local" id="FromDate" name="FromDate" value={this.state.FromDate} onChange={this.changeHandler} className="form-control" min={this.state.createdDate} />
                                    </div>
                                </div>
                            </Row>
                            <Row className="justify-content-center align-items-center">
                                <div className="col-md-3 col-12">
                                    <label className="font-weight-bold text-right">To Date</label>
                                </div>
                                <div className="col-md-4 col-12">
                                    <div className="form-label-group">
                                        <input type="datetime-local" id="ToDate" name="ToDate" value={this.state.ToDate} onChange={this.changeHandler} className="form-control" min={this.state.FromDate} />
                                    </div>
                                </div>
                            </Row>
                            <div>
                                <div class="pull-middle">
                                    <div className="form-label-group">
                                        <Button
                                            className="btn-shell"
                                            variant="warning"
                                            onClick={this.BindManualTransactionDetailGrid}
                                        >
                                            Show
                                        </Button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 col-12">
                                <h6 className="pull-left">Manual Transactions</h6>
                                <>
                                    <Toast ref={(el) => this.toast = el} />
                                    <div className="text-right mb-2">

                                        <input type="text" className="pb-2 form-control col-sm-2 col-12 pull-right" id="user-name" name="globalSearchBox" placeholder="Search..." onChange={this.changeHandler} />
                                    </div>
                                    <br></br>
                                    <br></br>
                                    <DataTable dataKey={this.state.datakeyName} ref={this.dt} class="Table" value={this.state.TransactionDetaildata} paginator rows={this.state.PageSize} sortMode="multiple" globalFilter={this.state.globalSearchBox} >
                                        {
                                            this.state.TransactionDetailcolumns.map(
                                                (item, index) => (
                                                    <Column field={item.MappingColomn} header={item.HeaderText} sortable></Column>
                                                )
                                            )
                                        }
                                        <Column body={this.actionEditTemplate}></Column>
                                        <Column body={this.actionDeleteTemplate}></Column>
                                    </DataTable>
                                </>
                            </div>
                        </Card.Body>
                    </Card>
                </Row>
                <Modal show={this.state.openModel} onHide={this.closeModel} animation={true} centered style={{ zIndex: 99999 }}>
                    <Modal.Header closeButton>
                        <Modal.Title>Edit Transaction </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form onSubmit={this.TransactionSaved}>
                            <div className="modal-body">
                                <label>Type: </label>
                                <div className="form-group">
                                    <Select
                                        className=""
                                        options={this.state.Type}
                                        styles={customStyles}
                                        onChange={this.onChange}

                                    ></Select>
                                </div>
                                <label>{this.state.SelectedType + ' Value'}</label>
                                <div className="form-group">
                                    <input type="text" className="form-control" name="Value" value={this.state.Value} onChange={this.changeHandler} required />
                                </div>
                            </div>
                            <div className="modal-footer">
                                <Button variant="secondary" onClick={this.closeModel}>Close</Button>
                                <button className="btn btn-shell" >Save</button>
                            </div>
                        </form>
                    </Modal.Body>
                </Modal>
            </>

        );
    }
}

export default EditManualTransaction;









